import React, { useState } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { COLORS, SIZES } from "theme";
import RightPathWhite from "assets/rightpathWhite.png";
import RightPath from "assets/rightPath.svg";
import Button from "ReusableComponents/Button";

const DealershipInfo = ({ info, getAction, small }) => {
  const [hover, setHover] = useState(false);
  return (
    <Box
      textAlign="center"
      display="flex"
      flexDirection="column"
      padding={small ? "20px" : "80px"}
    >
      <Text
        textColor="white"
        fontWeight="bold"
        fontSize={small ? SIZES.twentyFour : "40px"}
        margin={small ? 0 : "40px 0"}
      >
        {info?.attributes?.title}
      </Text>
      <Box margin={"24px auto"} w={small ? "100%" : "1060px"}>
        <Text
          textColor="#B8B8B8"
          fontSize={small ? SIZES.fourteen : "20px"}
          lineHeight="1.5"
          margin="0"
        >
          {info?.attributes?.description}
        </Text>
        <Text
          textColor="#B8B8B8"
          fontSize={small ? SIZES.fourteen : "20px"}
          margin="20px 0"
          lineHeight="1.5"
        >
          {info?.attributes?.description2}
        </Text>
      </Box>
      <Button
        background={hover ? COLORS.black : COLORS.primary}
        display="flex"
        w="218px"
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        hoverBackground={true}
        margin={small ? "20px auto" : "36px auto"}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={() => getAction("form")}
      >
        <Text
          fontSize={small ? SIZES.twelve : "16px"}
          fontWeight="bold"
          textColor={hover ? COLORS.white : COLORS.black}
        >
          Take the next step
        </Text>
        <img
          src={hover ? RightPathWhite : RightPath}
          alt="arrow"
          style={{ margin: "0 8px", height: 16 }}
        />
      </Button>
    </Box>
  );
};

export default DealershipInfo;
